import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'Zarejestruj',
  type: 'object',
  properties: {
    termIds: {
      type: 'array',
      items: { type: 'number' },
      calc: [
        'var selectedTerms = [];',
        'var keys = Object.keys(this.terms);',
        'for (var i = 0; i < keys.length; i++) {',
        '  var key = keys[i];',
        '  if (this.terms[key]) {',
        '    selectedTerms.push(parseInt(key.replace("term_", "")));',
        '  }',
        '}',
        'return selectedTerms;'
      ]
    },
    terms: {
      computed: true,
      type: 'object',
      properties: {}
    },
    login: {
      title: 'Adres e-mail',
      format: 'email',
      type: 'string',
      fieldRequired: true,
      validationMessages: {
        format: 'Nieprawidłowy format, nazwa użytkownika musi być wprowadzona w formacie nazwa@domena.'
      },
      validFunc: 'this.loginAvailable || "Podany adres email jest już zajęty"'
    },
    loginAvailable: {
      computed: true,
      type: 'boolean',
      default: true
    },
    profile: {
      type: 'object',
      properties: {
        firstName: {
          title: 'Imię',
          type: 'string',
          fieldRequired: true
        },
        lastName: {
          title: 'Nazwisko',
          type: 'string',
          fieldRequired: true
        },
        email: {
          title: 'Adres e-mail',
          type: 'string',
          calc: '$root.login'
        },
        phoneNumber: {
          title: 'Numer telefonu (opcjonalne)',
          type: 'string',
          fieldRequired: false
        },
        birthDate: {
          title: 'Data urodzenia',
          type: 'string',
          format: 'date',
          fieldRequired: true,
          validationMessages: {
            format: 'Nieprawidłowy format. Przykład: 01.01.1990'
          },
        },
        gender: {
          title: 'Płeć',
          type: 'number',
          fieldRequired: true
        },
        woj: {
          title: 'Województwo',
          type: 'string',
          fieldRequired: true
        },
        pow: {
          title: 'Powiat',
          type: 'string',
          fieldRequired: true
        },
        gmi: {
          title: 'Gmina',
          type: 'string',
          fieldRequired: true
        },
        terc: {
          title: 'Kod TERC',
          type: 'string',
          fieldRequired: true,
          minLength: 6
        },
        city: {
          title: 'Miejscowość',
          type: 'string',
          fieldRequired: true
        },
        simc: {
          title: 'Kod SIMC',
          type: 'string',
          fieldRequired: true
        },
        street: {
          title: 'Ulica',
          type: 'string',
          fieldRequired: true
        },
        ulic: {
          title: 'Kod ULIC',
          type: 'string',
          fieldRequired: false
        },
        postalCode: {
          title: 'Kod pocztowy',
          type: 'string',
          format: 'kod',
          fieldRequired: true,
          validationMessages: {
            format: 'Niepoprawny kod pocztowy'
          }
        },
        homeNumber: {
          title: 'Numer budynku*',
          type: 'string',
          fieldRequired: true
        },
        localNumber: {
          title: 'Numer lokalu (opcjonalne)',
          type: 'string',
          fieldRequired: false
        },
        type: {
          type: 'string',
          default: 'CLIENT',
          disabled: true
        }
      }
    }
  }
};
